export enum ContactRouterDrawerType {
  NewContact = "NewContact",
  ExistingContact = "ExistingContact",
  EditingContact = "EditingContact",
}
